const microServices = {
  USER_SERVICE: "/user-service/api/super-admin",
};

export const endpoints = {
  SUPER_ADMIN_GATEWAY_AND_PRICE_SMS: `${microServices.USER_SERVICE}/campaign/sms/default-gateway-price-map`,
  SUPER_ADMIN_GATEWAY_AND_PRICE_EMAIL: `${microServices.USER_SERVICE}/campaign/pricing/global/email`,
  SUPER_ADMIN_GATEWAY_AND_PRICE_WHATSAPP: `${microServices.USER_SERVICE}/campaign/pricing/global/whatsapp`,
  SUPER_ADMIN_WHATSAPP_PRICE_2: `${microServices.USER_SERVICE}/campaign/whatsapp/default-price-map`,
  SUPER_ADMIN_RCS_PRICE: `${microServices.USER_SERVICE}/campaign/rcs/default-price-map`,

};
